import { Component } from 'preact'

const editors = {}
export default class extends Component {
  componentDidMount () {
    require.ensure([], (require) => {
      const WysiwygEditor = require('@insided/editor-wysiwyg')
      editors[this.props.id] = new WysiwygEditor(this.props.options)
    }, 'wysiwyg-editor')
  }

  render (props) {
    return (
      <div id={props.id} className='wysiwyg-editor__textarea' />
    )
  }
}

export function returnContent (id) {
  return editors[id] ? editors[id].getDialectContent() : null
}
